<template>
    <Header ref="header" helpURL="studio/projects/">
      <template #header-slot>
        <BreadcrumbNavigation />
      </template>
      <template #extra-slot>
        Model Runner
      </template>
    </Header>
   <div class="main">
      <RunModel 
        :modelURL="modelURL"
        />
    </div> 
</template>

<script setup>
import Header from '@/components/Header.vue';
import BreadcrumbNavigation from '@/components/BreadcrumbNavigation.vue';
import RunModel from '@/components/ModelRunner/modelrunner.vue';
import { useRoute} from 'vue-router';
const route = useRoute();
import {ref, onMounted} from 'vue';

const  modelURL =ref("");


onMounted(async () => {
  
  const trainerID=route.query.trainer;
  const modelFile=route.query.model;
    
  modelURL.value='/download_model?training_session_id='+trainerID+"&file="+modelFile;
  
});

function parseID(v) {
  let id=0
  if  (v.includes("-")) {
     id=parseInt(v.split("-")[1], 16);
  } else {
    id=parseInt(v);
  }
  return id;
}

</script>

<style lang="scss" scoped>
.main {
  display: flex;
  justify-content: center;
}
.app-page {
  align-items: center;
  text-align: center;
  overflow: visible;
  height: 100dvh;
  background-color: #250e81 !important;
  background-image: url("@/assets/img/blu-stripes.png") !important;
}

.signup {
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  height: 100%;
  padding: 16px 100px;
  align-items: center;
  // justify-content: center;
  overflow: auto;
}

@media (max-width: $breakpoint-sm) {
  .signup {
    padding: 8px;
  }
}
@media (max-width: $breakpoint-md) {
  .signup {
    padding: 16px;
  }
}

.top-msg {
  margin: 20px;
}

.scroll {
  overflow-y: scroll;
}

</style>
